module.exports = __webpack_public_path__ + "img/terracenew_box17.4bfad05c.jpg";